/* EntriesTable styles - extracted from Attorney.module.css */

/* Scrollable container for entries */
.scrollContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  justify-content: flex-start;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 650px;
}

/* ============================================
   HEADER ROW
   ============================================ */
.headerRow {
	height: 7%;
	width: 100%;
	color: var(--brand-dark-green);
	flex-direction: row;
	display: flex;
	align-items: stretch;
	font-size: 0.8125rem;
	padding: 10px 0px 10px 20px;
	font-weight: 600;
	flex-shrink: 0;
	background-color: var(--secondary);
	border-radius: var(--radius) var(--radius) 0 0;
	box-sizing: border-box;
	user-select: none;
	border-bottom: 1px solid var(--border);
}

:global(.dark) .headerRow {
  background-color: var(--card);
  color: var(--foreground);
  border-bottom: 1px solid var(--border);
}

.headerLeft {
  width: 85%;
  display: flex;
  justify-content: left;
  align-items: stretch;
  gap: 20px;
  flex-shrink: 0;
}

.headerCheckbox {
  width: 2%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.headerApp {
  width: 3%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.headerDate {
  width: 7%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  text-align: left;
}

.headerMatter {
  width: 25%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  text-align: left;
}

.headerCodes {
  width: 7%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  text-align: left;
}

.headerNarrative {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-shrink: 0;
}

.headerTitle {
  width: 10%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  text-align: left;
}

.headerUnitsWrapper {
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  padding-right: 20px;
}

/* ============================================
   ENTRY ROW
   ============================================ */
.entryRow {
	height: auto;
	min-height: 56px;
	width: 100%;
	color: var(--foreground);
	flex-direction: row;
	display: flex;
	align-items: center;
	font-size: 0.8125rem;
	padding: 10px 0 10px 20px;
	font-weight: 400;
	flex-shrink: 0;
	box-sizing: border-box;
	cursor: default;
	border-bottom: 1px solid color-mix(in oklch, var(--border) 30%, transparent);
	transition: background-color 0.15s ease;
}

:global([data-palette="default"]) .entryRow {
  border-bottom: 1px solid var(--border);
}

:global(.dark) .entryRow {
  background-color: var(--background);
  color: var(--foreground);
}

.entryRow:hover {
  background-color: color-mix(in oklch, var(--secondary) 60%, transparent);
}

:global(.dark) .entryRow:hover {
  background-color: var(--card);
}

:global(.dark[data-palette="default"]) .entryRow:hover {
  background-color: #262626;
}

.failedRow {
  border-left: 3px solid var(--destructive);
}

.exportingRow {
  opacity: 0.55;
  pointer-events: none;
  cursor: not-allowed;
}

.mutatingRow {
  opacity: 0.5;
  pointer-events: none;
  transition: opacity 0.2s;
}

.entryLeft {
  width: 85%;
  display: flex;
  justify-content: left;
  align-items: stretch;
  gap: 20px;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
}

.entryCheckbox {
  width: 2%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.entryApp {
  width: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.appLogo {
  width: 30px;
  height: 30px;
}

.entryDate {
  width: 7%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dateTimeWrapper {
  display: flex;
  flex-direction: column;
  gap: 1px;
  line-height: 1.3;
}

.timeRange {
  font-size: 0.6875rem;
  color: var(--muted-foreground);
  white-space: nowrap;
}

/* ============================================
   MATTER/CLIENT COLUMN
   ============================================ */
.matterWrapper {
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-break: break-word;
  flex-shrink: 0;
  min-height: 36px;
}

.matterText {
	font-size: 0.8125rem;
	font-weight: 500;
	color: var(--foreground);
}

:global(.dark) .matterText {
  color: var(--foreground);
}

.clientText {
	font-size: 0.75rem;
	font-weight: 400;
	color: var(--muted-foreground);
	text-wrap: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

:global(.dark) .clientText {
  color: var(--muted-foreground);
}

/* ============================================
   CODES COLUMN (Task/Activity)
   ============================================ */
.codesWrapper {
  width: 7%;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
}

/* ============================================
   NARRATIVE COLUMN
   ============================================ */
.narrative {
	font-size: 0.8125rem;
	font-weight: 400;
	line-height: 1.4;
	height: auto;
	text-align: left;
	white-space: normal;
	word-wrap: break-word;
	flex-shrink: 1;
	padding-right: 10px;
	min-width: 0;
	display: flex;
	align-items: flex-start;
	gap: 6px;
}

.feedbackWarning {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.warningIcon {
  width: 16px;
  height: 16px;
  color: #d97706; /* amber-600 */
}

:global(.dark) .warningIcon {
  color: #fbbf24; /* amber-400 */
}

/* ============================================
   DOCUMENT TITLE COLUMN
   ============================================ */
.documentTitle {
  width: 10%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  align-content: safe center;
  flex-shrink: 1;
}

/* ============================================
   UNITS/STATUS COLUMN
   ============================================ */
.unitsWrapper {
  width: 15%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 6px 20px;
  flex-shrink: 0;
  padding-right: 10px;
}

.unitsBadge {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 7px;
	color: var(--background);
	background-color: var(--brand-dark-green);
	border: 1px solid var(--background);
	padding: 5px 10px;
	width: auto;
	min-width: 50px;
	font-size: 0.8125rem;
	font-weight: 525;
}

:global(.dark) .unitsBadge {
  color: var(--foreground);
  background-color: var(--card);
  border: none;
}

:global([data-palette="default"]) .unitsBadge {
  background-color: var(--primary);
}

:global(.dark[data-palette="default"]) .unitsBadge {
  background-color: var(--card);
}

/* Status badges */
.failedBadge {
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 70px;
  color: var(--destructive);
  background-color: color-mix(in oklch, var(--destructive) 10%, transparent);
  border: 1px solid color-mix(in oklch, var(--destructive) 50%, transparent);
}

:global(.dark) .failedBadge {
  color: var(--destructive);
  background-color: color-mix(in oklch, var(--destructive) 10%, transparent);
  border: 1px solid var(--border);
}

.exportedBadge {
	font-size: 0.6875rem;
	font-weight: 600;
	padding: 4px 10px;
	border-radius: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 70px;
	color: var(--success);
	background-color: color-mix(in oklch, var(--success-soft) 10%, transparent);
	border: 1px solid color-mix(in oklch, var(--success) 50%, transparent);
}

:global(.dark) .exportedBadge {
  color: var(--success);
  background-color: color-mix(in oklch, var(--success-soft) 10%, transparent);
  border: 1px solid var(--border);
}

.incompleteBadge {
	font-size: 0.6875rem;
	font-weight: 600;
	padding: 4px 10px;
	border-radius: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 70px;
	color: var(--destructive);
	background-color: color-mix(in oklch, var(--destructive) 10%, transparent);
	border: 1px solid color-mix(in oklch, var(--destructive) 50%, transparent);
}

.trackedBadge {
	font-size: 0.6875rem;
	font-weight: 600;
	padding: 4px 10px;
	border-radius: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 70px;
	color: var(--warning);
	background-color: color-mix(in oklch, var(--warning-soft) 10%, transparent);
	border: 1px solid color-mix(in oklch, var(--warning) 50%, transparent);
}

:global(.dark) .trackedBadge {
  color: var(--warning);
  background-color: color-mix(in oklch, var(--warning-soft) 10%, transparent);
  border: 1px solid var(--border);
}

.exportingBadge {
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 70px;
  color: var(--brand-teal, hsl(var(--primary)));
  background-color: color-mix(in oklch, var(--brand-teal, hsl(var(--primary))) 10%, transparent);
  border: 1px solid color-mix(in oklch, var(--brand-teal, hsl(var(--primary))) 50%, transparent);
}

:global(.dark) .exportingBadge {
  color: var(--brand-teal, hsl(var(--primary)));
  background-color: color-mix(in oklch, var(--brand-teal, hsl(var(--primary))) 10%, transparent);
  border: 1px solid var(--border);
}

/* ============================================
   DATE GROUP HEADER
   ============================================ */
.dateGroupHeader {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 4px 15px 4px 20px;
  background-color: var(--secondary);
  border-top: 1px solid var(--border);
}

@media (max-width: 1000px) {
  .dateGroupHeader {
    justify-content: flex-start;
  }
}

:global(.dark) .dateGroupHeader {
  background: var(--card);
  border-top: 1px solid var(--border);
}

.dateText {
	display: flex;
	justify-content: left;
	align-items: center;
	font-size: 0.75rem;
	font-weight: 600;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	color: var(--muted-foreground);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-height: 18px;
}

.groupTotal {
	font-size: 0.75rem;
	font-weight: 600;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	color: var(--muted-foreground);
	white-space: nowrap;
}

/* ============================================
   EMPTY STATE
   ============================================ */
.emptyState {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.emptyText {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 0.875rem;
	color: var(--muted-foreground);
}

:global(.dark) .emptyText {
  color: var(--muted-foreground);
}

/* ============================================
   CHECKBOX HIT AREA
   ============================================ */
.checkboxHitArea {
  display: inline-flex;
  align-items: center;
  padding: 6px 8px;
  margin: -6px -8px;
  cursor: pointer;
  user-select: none;
}

.selectionCount {
  font-size: 0.6875rem;
  font-weight: 600;
  color: var(--brand-dark-teal, hsl(var(--primary)));
  white-space: nowrap;
}

/* ============================================
   INTERMEDIATE RESPONSIVE STYLES
   Hide less-important columns and relax min-width
   to prevent table from overflowing into header
   ============================================ */
/* ============================================
   MOBILE RESPONSIVE STYLES
   ============================================ */
@media screen and (max-width: 650px) {
  .scrollContainer {
    min-width: unset;
  }

  .headerRow {
    min-width: unset;
  }

  .entryRow {
    min-width: unset;
  }

  .headerTitle {
    display: none;
  }

  .documentTitle {
    display: none;
  }
  .scrollContainer {
    flex: 1 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
    height: 100% !important;
    min-width: unset !important;
  }

  .headerRow {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    flex-shrink: 0 !important;
    min-width: unset !important;
    width: 100% !important;
  }

  .entryRow {
    min-width: unset !important;
    width: 100% !important;
    flex-shrink: 0 !important;
  }

  /* Hide columns except checkbox, matter, and units on mobile */
  .headerApp,
  .headerDate,
  .headerCodes,
  .headerNarrative,
  .headerTitle {
    display: none !important;
  }

  .entryApp,
  .entryDate,
  .codesWrapper,
  .narrative,
  .documentTitle {
    display: none !important;
  }

  /* Adjust widths for mobile - checkbox, matter, and units only */
  .headerCheckbox {
    width: 15% !important;
  }

  .headerMatter {
    width: 70% !important;
  }

  .headerUnitsWrapper {
    width: 15% !important;
  }

  .entryCheckbox {
    width: 15% !important;
  }

  .matterWrapper {
    width: 70% !important;
  }

  .unitsWrapper {
    width: 15% !important;
  }

  /* Adjust left container width for mobile */
  .headerLeft {
    width: 85% !important;
  }

  .entryLeft {
    width: 85% !important;
  }
}
